import { notifyLike, notifyComparison, notifySubscribe } from '@/features/notify/notify.js';

window.app.notifyLike = notifyLike;
window.app.notifyComparison = notifyComparison;
window.app.notifySubscribe = notifySubscribe;

window.addEventListener('DOMContentLoaded', () => {});
